var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SocialBase',{attrs:{"url":_vm.url,"fb-text":((_vm.video.title) + " - " + (_vm.video.social.facebook)),"tw-text":((_vm.video.title) + " - " + (_vm.video.social.twitter))}})}
var staticRenderFns = []

export { render, staticRenderFns }